import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParams = () => {
  const location = useLocation();
  
  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const params: Record<string, string> = {};
    
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    
    return params;
  }, [location.search]);
};

export const useQueryParam = (key: string): string | null => {
  const params = useQueryParams();
  return params[key] || null;
};
